import React, { useRef, useEffect, useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import animateScrollTo from 'animated-scroll-to';
import { getNavbarHeight } from '../../../models/Utils';

import VideoBanner from '../subcomponents/VideoBanner/VideoBanner';
import TwoColumnSlider from '../subcomponents/TwoColumnSlider/TwoColumnSlider';
import PillarSlider from '../subcomponents/PillarSlider/PillarSlider';
import NextStory from '../../Common/NextStory/NextStory';
import { getViewportDimensions } from '../../../models/Utils';
import ExhibitMenu from '../../Common/ExhibitMenu/ExhibitMenu';
import {
  setHasVisitedBBF
} from '../../../store/reducers/mainReducer';

import { ADALandmarks } from '../../../models/ADA';
import './PillarsIntro.scss';

const PillarsIntro = props => {
  const dispatch = useDispatch();
  const initialized = useSelector(state => state.data.initialized);
  const cmsData = useSelector(state => state.data.cms.buildingBrighterFutures);
  const navbar = useSelector(state => state.data.menus.buildingBrighterFutures);
  const cmsMediaPath = useSelector(state => state.config.basePath + state.config.apiMediaPath);
  const [creditsActive, setCreditsActive] = useState(false);
  const tcs = useRef(null);
  const creditsElement = useRef(null);

  useEffect(() => {
    document.title = "The Verizon Story - Rooted in Responsibility";
    dispatch(setHasVisitedBBF(true));
  }, []);

  const handleScroll = () => {
    if(creditsElement && creditsElement.current){
      const sliderRect = creditsElement.current.getBoundingClientRect();
      const windowHeight = getViewportDimensions().height;
      if ((sliderRect.y <= windowHeight)) {
        setCreditsActive(true);
      }
      else if ((sliderRect.y > windowHeight)) {
        setCreditsActive(false);
      }
    }
  };

  useLayoutEffect(() => {
    handleScroll();

    document.body.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    return () => {
      document.body.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  }, []);

  if(!initialized){
    return null;
  }

  cmsData.Introduction.OurResponsibility.Boxes.forEach(box => {
    if (box.Background.Image && box.Background.Image.indexOf(cmsMediaPath) < 0) {
      box.Background.Image = cmsMediaPath + box.Background.Image;
    }
  });

  cmsData.Introduction.ExploreMore.Cards.forEach(card => {
    if (card.Background.Image && card.Background.Image.indexOf(cmsMediaPath) < 0) {
      card.Background.Image = cmsMediaPath + card.Background.Image;
    }
  });

  const scrollToTCS = () => {
    animateScrollTo(tcs.current.getBoundingClientRect().y + document.body.scrollTop - getNavbarHeight(), {
      elementToScroll: document.body
    });
  };

  return (
    <div className="bbf-home" role={ADALandmarks.Main}>
      <ExhibitMenu title={cmsData ? cmsData.Introduction.Title : ""} links={navbar}/>
      <VideoBanner
        bgndVideo={cmsData.Introduction.InitVideo.Background}
        title={cmsData.Introduction.InitVideo.Subheader}
        text={cmsData.Introduction.InitVideo.Body}
        bigFont={true}
        onGoDown={ () => scrollToTCS() }
      />
      <TwoColumnSlider ref={tcs} data={cmsData.Introduction.OurResponsibility}/>
      <PillarSlider data={cmsData}/>
      <div ref={creditsElement}>
        <NextStory 
          showNext={creditsActive}
          showCredits={creditsActive}
          next={`/${cmsData.Path.Text}/${cmsData.Pillars[0].Menu.Path}`}
          title={`Up next: ${cmsData.Pillars[0].Name}`}
          subtitle={cmsData.Pillars[0].InitialVideo.Header}
          onCreditsClick={() => {}}
          />
      </div>
    </div>
  );
};

export default PillarsIntro;
